import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useExamsList } from "../stores/courses/exam";
import {
  ArrowLeftIcon,
  CheckCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";

const ExamDetail = () => {
  const { examId } = useParams();
  const navigate = useNavigate();
  const { exam, isLoading, error, fetchExamDetail } = useExamsList();

  useEffect(() => {
    if (examId) {
      fetchExamDetail(examId);
    }
    console.log(exam);
  }, [examId, fetchExamDetail]);

  if (isLoading) {
    return <div className="p-8 text-center">Loading exam details...</div>;
  }

  if (error) {
    return <div className="p-8 text-center text-red-500">Error: {error}</div>;
  }

  if (!exam) {
    return <div className="p-8 text-center">No exam data found.</div>;
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 max-w-4xl mx-auto">
      <div className="mb-6">
        <button
          onClick={() => navigate(-1)} // Go back to the previous page
          className="bg-gray-600 hover:bg-gray-700 text-white px-3 py-1 rounded-md flex items-center"
        >
          <ArrowLeftIcon className="h-4 w-4 mr-2" /> Back
        </button>
      </div>

      {/* Exam Info Card */}
      <div className="bg-white shadow-lg rounded-lg p-6 mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">{exam.title}</h1>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-gray-500 mb-4">
          <span className="font-semibold text-gray-700">Level:</span>{" "}
          {exam.level_name}
          <span className="font-semibold text-gray-700">Category:</span>{" "}
          {exam.category_name}
          <span className="font-semibold text-gray-700">Duration:</span>{" "}
          {exam.duration} mins
        </div>
        <p className="text-gray-600 mb-6">{exam.description}</p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center border-t border-b py-4">
          <div>
            <p className="text-sm text-gray-500">Passing Score</p>
            <p className="text-xl font-bold text-blue-600">
              {exam.passing_score}%
            </p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Attempts</p>
            <p className="text-xl font-bold text-gray-800">
              {exam.attempts_count}
            </p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Passes</p>
            <p className="text-xl font-bold text-green-600">
              {exam.pass_count}
            </p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Pass Rate</p>
            <p className="text-xl font-bold text-green-600">{exam.pass_rate}</p>
          </div>
        </div>
      </div>

      {/* Questions List */}
      <div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Questions</h2>
        <div className="space-y-6">
          {exam.questions &&
            exam.questions.map((question, index) => (
              <div
                key={question.id || index}
                className="bg-white shadow rounded-lg p-5"
              >
                <div className="flex justify-between items-start mb-3">
                  <p className="text-lg font-medium text-gray-800">
                    <span className="font-bold">Q{index + 1}:</span>{" "}
                    {question.text}
                  </p>
                  <span className="text-sm font-semibold text-gray-500 bg-gray-100 px-2 py-1 rounded">
                    {question.points || question.score} Points
                  </span>
                </div>
                <ul className="space-y-2 pl-4">
                  {question.options &&
                    question.options.map((option, oIndex) => (
                      <li
                        key={option.id || oIndex}
                        className="flex items-center"
                      >
                        {option.is_correct ? (
                          <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0" />
                        ) : (
                          <XCircleIcon className="h-5 w-5 text-red-500 mr-2 flex-shrink-0" />
                        )}
                        <span
                          className={`text-gray-700 ${
                            option.is_correct ? "font-bold" : ""
                          }`}
                        >
                          {option.text}
                        </span>
                      </li>
                    ))}
                </ul>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ExamDetail;
